/**
 * `/app/perfis` — rota antiga.
 *
 * "Papéis e permissões" deixou de ser uma tela própria e virou uma ABA de
 * `TelaUsuarios.tsx` (`/app/usuarios?aba=perfis`), para caber no mesmo lugar
 * de onde se convida e edita acesso — a decisão de arquitetura que tornou a
 * matriz editável por loja está em docs/de-para.md.
 *
 * Este componente só existe para quem tinha o endereço antigo salvo (ou
 * clicava num link antigo) continuar chegando a algum lugar, em vez de ver
 * "página não encontrada" depois de uma mudança de rota que não é da conta
 * dele.
 */
import { Navigate } from 'react-router-dom'

export function TelaPerfis() {
  return <Navigate to="/app/usuarios?aba=perfis" replace />
}
